import { IconNames } from '@blueprintjs/icons';
import { capitalizeString } from '@strata/helper-functions';
import { ActionButtonText } from '@strata/react-buttons';
import { InfoDialog } from '@strata/react-dialog';
import { Grid } from '@strata/react-grid';
import PropTypes from 'prop-types';

const columns = [
    {
        header: 'Sheet',
        accessorKey: 'sheet_name',
        size: 100,
    },
    {
        header: 'Column',
        accessorKey: 'column_name',
        size: 100,
    },
    {
        header: 'Row',
        accessorKey: 'row_index',
        size: 80,
    },
    {
        header: 'Error',
        accessorKey: 'msg',
        size: 200,
    },
];

/** Exports array of data to csv using keys as column headers */
const exportCsv = (data, filename) => {
    const csvHeader = `${Object.keys(data[0])
        .map((header) => capitalizeString(header))
        .join(',')}\n`; // header row
    const csvBody = data.map((row) => Object.values(row).join(',')).join('\n');

    const hiddenElement = document.createElement('a');
    hiddenElement.href = `data:text/csv;charset=utf-8,${encodeURI(csvHeader + csvBody)}`;
    hiddenElement.target = '_blank';
    hiddenElement.download = `${filename}.csv`;
    hiddenElement.click();
};

export const BulkUploadValidationErrorsDialog = ({
    uploadName,
    isOpen,
    onClose,
    validationErrors = undefined,
}) => (
    <InfoDialog
        dialogTitle="Bulk Upload Errors"
        isOpen={isOpen}
        onClose={onClose}
        width={800}
        dialogContent={
            <>
                <div
                    className="flex__gap--small margin__bottom--medium"
                    style={{ justifyContent: 'space-between' }}
                >
                    <span>
                        {`Below are the errors that occurred while uploading the ${uploadName.toLowerCase()} file.`}
                    </span>
                    <ActionButtonText
                        label="Download Errors"
                        leftIcon={IconNames.IMPORT}
                        onClick={() => exportCsv(validationErrors, `${uploadName} Upload Errors`)}
                    />
                </div>
                <Grid
                    data={validationErrors}
                    columns={columns}
                    sortProperties={[{ id: 'row_index', desc: false }]}
                />
            </>
        }
    />
);

BulkUploadValidationErrorsDialog.propTypes = {
    uploadName: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    validationErrors: PropTypes.arrayOf(
        PropTypes.shape({
            sheet_name: PropTypes.string.isRequired,
            column_name: PropTypes.string.isRequired,
            row_index: PropTypes.number.isRequired,
            msg: PropTypes.string.isRequired,
        }).isRequired,
    ),
};
